import { ILogType, IAuditLog } from '../common/defaults';
import axios from 'axios';
import { elasticRequest } from '../../../services/elasticService';
const $ = require('jquery');
// types
export enum AuditLogActionTypes {
  GET_LOG_TYPES = '@@auditLogs/GET_LOG_TYPES',
  GET_LOGS_BY_TYPE = '@@auditLogs/GET_LOGS_BY_TYPE',
  SELECTED_LOG_TYPE = '@@auditLogs/SELECTED_LOG_TYPE',
}

export const getLogTypes = (url: string) => {
  return async (dispatch) => {
    try {
      elasticRequest(url).then((result: any) => {
        let justData: any[] = [];
        // Guard against failed/empty Elasticsearch responses (e.g. HTTP 400,
        // timeout, or unreachable cluster) which resolve `result` to undefined.
        // Without this guard, reading `result.hits.hits` throws and blanks the page.
        if (result && result.hits && result.hits.hits) {
          Object.keys(result.hits.hits).forEach((i) => {
            justData.push(result.hits.hits[i]._source);
          });
        }
        dispatch(reduceLogTypes(justData));
      }).catch((error) => {
        console.log(error);
        dispatch(reduceLogTypes([]));
      });
    } catch (ex) {
      console.log(ex);
    }
  };
};

export const reduceLogTypes = (logTypes: ILogType[]) => {
  return {
    type: AuditLogActionTypes.GET_LOG_TYPES,
    value: logTypes,
  };
};

export const getLogsByType = (url: string, type: string, mustQuery: any) => {
  return async (dispatch) => {
    if (type === '-1') dispatch(reduceLogs([], type));
    else {
      try {
        const params: any = {};
        if (mustQuery) {
          const query = {
            query: {
              bool: {
                must: mustQuery,
              },
            },
          };
          params.source = JSON.stringify(query);
          params.source_content_type = 'application/json';
        }
        elasticRequest(url, params.source)
          .then((resp: any) => {
            let justData: any[] = [];
            // Guard against failed/empty Elasticsearch responses which resolve
            // `resp` to undefined; reading `resp.hits.hits` would otherwise throw.
            if (resp && resp.hits && resp.hits.hits) {
              Object.keys(resp.hits.hits).forEach((i) => {
                let data = resp.hits.hits[i]._source;
                data.id = resp.hits.hits[i]._id;
                justData.push(data);
              });
            }
            dispatch(reduceLogs(justData, type));
          })
          .catch(function (error) {
            // handle error
            console.log(error);
            dispatch(reduceLogs([], type));
          });
      } catch (ex) {
        console.log(ex);
      }
    }
  };
};

export const reduceLogs = (logs: IAuditLog[], type: string) => {
  return {
    type: AuditLogActionTypes.GET_LOGS_BY_TYPE,
    value: { logs: logs, type: type },
  };
};
